<div class="suspend-station-dialog">
  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'suspend station' | translate: ['tmc-yard.widgets.sac-client.suspend-station-dialog.title', translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="dialog-content">
      <mat-form-field class="textarea-note">
        <textarea matInput [maxLength]="255" [rows]="3"
          placeholder="{{'note' | translate: ['tmc-yard.widgets.sac-client.suspend-station-dialog.note', translationService.language]}}"
          [(ngModel)]="note" required></textarea>
      </mat-form-field>
    </div>

    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>
    <i class="horizontal-divider"></i>
    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancelDialog()" [disabled]="false">{{'cancel' |
        translate:['shared.selection-dialog.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="suspendStation()" class="confirm-button"
        [disabled]="isSupendStationDisabled()">{{'suspend' |
        translate:['tmc-yard.widgets.sac-client.suspend-station-dialog.action.confirm', translationService.language]}}</button>
    </sc-actionbar>
  </div>
</div>
